import { render, staticRenderFns } from "./AddKeyword.vue?vue&type=template&id=3e1cf12e&"
import script from "./AddKeyword.vue?vue&type=script&lang=js&"
export * from "./AddKeyword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports